import type { SkillQuality } from '@/types/skill'

function expToLevelUp(level: number) {
  level = level + 1
  let base = 10 * Math.pow(1.15, level)
  let exp = base * level

  return Math.floor(exp)
}

// 根据当前经验判断技能等级
export function getSkillLevelByExp(exp: number) {
  let level = 0
  let accumulatedExp = 0

  while (level < 50) {
    let expForNextLevel = expToLevelUp(level)
    if (accumulatedExp + expForNextLevel > exp) {
      break
    }
    accumulatedExp += expForNextLevel
    level++
  }

  return level
}

// 根据当前经验判断下一级所需经验
export function getNextLevelExpByExp(exp: number) {
  let level = getSkillLevelByExp(exp)
  let nextLevelExp = expToLevelUp(level)
  let currentLevelExp = 0
  for (let i = 0; i < level; i++) {
    currentLevelExp += expToLevelUp(i)
  }
  return nextLevelExp - (exp - currentLevelExp)
}

const qualityExpMap: Record<SkillQuality, number> = {
  normal: 2,
  race: 8,
  epic: 32,
  legend: 128,
  antiquity: 512,
}
export function getSkillExpByQuality(quality: SkillQuality) {
  return qualityExpMap[quality]
}
